import AbonosService from "@/services/cxc/AbonosService";
import TipoAbonoService from "@/services/cxc/TipoAbonoService";
import AbonoSerieService from "@/services/cxc/AbonoSerieService";


const fetch = (context, params) => {
  return AbonosService.fetch(params)
    .then(res => {
      context.commit('ABONOS', res.data);
    });
};

const setFilter = (context, params) => {
  context.commit('FILTERS', res.data);
  return AbonosService.fetch(params)
    .then(res => {
    });
};

const abonos = (context, params) => {
  return AbonoSerieService.fetch(params)
    .then(res => {
      context.commit('ABONOS', res.data);
    });
};


const tipoabono = (context, params) => {
  return TipoAbonoService.fetch(params)
    .then(res => {
      context.commit('TIPOABONO', res.data);
    });
};

const series = (context, params) => {
  return AbonoSerieService.fetch(params)
    .then(res => {
      context.commit('SERIES', res.data);
    });
};

export default {
  fetch,
  tipoabono,
  abonos,
  setFilter,
  series,
};